/**
 * Announcement Bar — marquesina en loop infinito (Laganini).
 * Track con DOS mitades identicas + translateX(-50%): el -50% es relativo al
 * ancho propio del track, por lo que la costura reposiciona exacta sea cual
 * sea el ancho de la fuente (NUNCA medir el shift en px). El JS solo decide
 * cuantas copias de la secuencia base necesita cada mitad para cubrir el
 * viewport y fija la duracion (px/s). Recalcula en fonts.ready y resize.
 * prefers-reduced-motion -> sin animacion (CSS centra el primer mensaje).
 */
(function () {
  'use strict';

  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function initBar(bar) {
    var track = bar.querySelector('[data-marquee-track]');
    var halves = bar.querySelectorAll('[data-marquee-half]');
    if (!track || halves.length !== 2) return;

    var bases = [];
    halves.forEach(function (half) {
      var base = half.querySelector('[data-marquee-base]');
      if (base && !base.dataset.marqueeHtml) base.dataset.marqueeHtml = base.innerHTML;
      bases.push(base);
    });
    if (!bases[0] || !bases[1]) return;

    function speed() {
      var mobile = window.matchMedia('(max-width: 749px)').matches;
      var v = mobile ? bar.dataset.speedMobile : bar.dataset.speed;
      return Math.max(parseInt(v, 10) || 40, 5);
    }

    function build() {
      if (reducedMotion.matches) {
        track.classList.remove('is-animated');
        track.style.removeProperty('--marquee-duration');
        bases.forEach(function (base) {
          base.innerHTML = base.dataset.marqueeHtml;
        });
        return;
      }

      // Restaura la secuencia base y mide su ancho real.
      bases.forEach(function (base) {
        base.innerHTML = base.dataset.marqueeHtml;
      });
      var baseWidth = bases[0].getBoundingClientRect().width;
      if (!baseWidth) return;

      // Copias por mitad: cada mitad debe ser >= ancho visible.
      var copies = Math.max(Math.ceil(window.innerWidth / baseWidth), 1);
      bases.forEach(function (base) {
        var html = base.dataset.marqueeHtml;
        for (var i = 1; i < copies; i++) base.innerHTML += html;
      });

      var halfWidth = baseWidth * copies;
      var duration = halfWidth / speed();
      track.style.setProperty('--marquee-duration', duration + 's');
      track.classList.add('is-animated');
    }

    build();

    var resizeTimer = null;
    window.addEventListener('resize', function () {
      window.clearTimeout(resizeTimer);
      resizeTimer = window.setTimeout(build, 200);
    });

    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(build);
    }

    if (reducedMotion.addEventListener) {
      reducedMotion.addEventListener('change', build);
    }
  }

  function boot() {
    document.querySelectorAll('[data-announcement-marquee]').forEach(initBar);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // Re-init en el editor de temas.
  document.addEventListener('shopify:section:load', function (e) {
    var bar = e.target.querySelector('[data-announcement-marquee]');
    if (bar) initBar(bar);
  });
})();
